import { ReactNode } from 'react'
import { giphyDarkGrey, giphyGreen, giphyLightestGrey, giphyRed, giphyWhite } from '@giphy/js-brand'
import { Container, ToggleBackground, Icon, Text } from './style'
import { Gradient } from 'types'

type Props = {
    toggle: Function
    clickOn?: () => void
    clickOff?: () => void
    isOn: boolean | undefined
    backgroundColor?: string
    onColor?: string | Gradient
    offColor?: string | Gradient
    onText?: string
    offText?: string
    onElement?: ReactNode
    offElement?: ReactNode
    height?: number
    width?: number
    className?: string
    borderRadius?: number
    iconOn?: string
    iconOff?: string
}

const Toggle = ({
    toggle,
    clickOn = () => {},
    clickOff = () => {},
    isOn,
    backgroundColor = giphyDarkGrey,
    onColor = giphyGreen,
    offColor = giphyRed,
    onElement,
    offElement,
    onText,
    offText,
    height = 40,
    width = 165,
    className,
    borderRadius,
    iconOn = giphyWhite,
    iconOff = giphyLightestGrey,
}: Props) => {
    const toggleAction = () => {
        toggle(isOn)
    }

    return (
        <Container
            backgroundColor={backgroundColor}
            borderRadius={borderRadius}
            className={className}
            onClick={toggleAction}
        >
            <ToggleBackground
                borderRadius={borderRadius}
                height={height}
                isOn={isOn}
                activeColor={onColor}
                offColor={offColor}
                width={width}
            />
            <Icon onClick={clickOn} height={height} iconOff={iconOff} iconOn={iconOn} isOn={isOn} width={width}>
                {onElement && onElement}
                {onText && <Text>{onText}</Text>}
            </Icon>
            <Icon onClick={clickOff} height={height} iconOff={iconOff} iconOn={iconOn} isOn={!isOn} width={width}>
                {offElement}
                {offText && <Text>{offText}</Text>}
            </Icon>
        </Container>
    )
}

export default Toggle
